import React from 'react'
import IndividualForm from '../../features/IndividualMemberTaskList/IndividualFrom'
export const IndividualMemberDataContext = React.createContext(null);
const IndividualMember = () => {
    return (
        <IndividualForm />
    )
}

export default IndividualMember